import request from "@/utils/request";

// 文章详情
export function getdetail1(data) {
  return request({
    url: "/api/party_building/rich_text",
    method: "get",
    params:data,
  });
}
export function getdetail2(data) {
    return request({
      url: "/api/science/rich_text",
      method: "get",
      params:data,
    });
  }
  